import React from 'react'
import { Flex, HStack, Text, IconButton } from '@chakra-ui/react'
import { X as XIcon } from '@components/icons'

type PanelHeaderPropsT = {
  title: string
  onClose: () => void
}

const PanelHeader: React.FC<PanelHeaderPropsT> = ({
  title,
  onClose,
}) => (
  <HStack h="72px" justifyContent="space-between" p="24px">
    <Flex>
      <Text fontWeight="bold">{title}</Text>
    </Flex>
    <Flex>
      <IconButton
        display="flex"
        variant="unstyled"
        icon={<XIcon fill="black" />}
        aria-label="Close"
        onClick={onClose}
      />
    </Flex>
  </HStack>
)

export default PanelHeader